import { api } from "../../api/endpoints";
import {
  GET_DAY_SCREEN_DATA_USAGE_STATS,
  GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL,
  GET_INTERNET_USAGE_PER_USER,
  GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL,
  GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS,
  GET_SCREEN_STAT_RANKING_DETAILS,
  GET_SCREEN_STAT_RANKING_DETAILS_FAIL,
  GET_SCREENS_STATS_RANKING_FAIL,
  GET_SCREENS_STATS_RANKING_SUCCESS,
  GET_TWENTY_DAYS_USER_STATS,
  GET_USER_RANKING
} from "../constant";

export const getScreenDataUsageStaticsPerDay = (obj) => {
  return async (dispatch) => {
    const { data, status } = await api.post(`/screenStats/getScreenDataUsageStaticsPerDay`, obj);
    if (status === 200) {
      dispatch({
        type: GET_DAY_SCREEN_DATA_USAGE_STATS,
        payload: data.dayScreenStat,
      });
    }else{
      dispatch({
        type: GET_DAY_SCREEN_DATA_USAGE_STATS_FAIL
      })
    }
  };
};

export const throwGetPeriodScreenStatsError = (error) => {
  return async (dispatch) => {
    dispatch({
      type: GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL,
      payload: error
    })
  }
}

export const getPeriodScreenStats = (obj) => {
  return async (dispatch) => {
    const { data, status } = await api.post(`/screenStats/getScreenDataUsageStaticsPeriod`, obj);
    if (status === 200) {
      dispatch({
        type: GET_PERIOD_SCREEN_DATA_USAGE_STATS_SUCCESS,
        payload: data.periodScreenStats,
      });
    }else{
      dispatch({
        type: GET_PERIOD_SCREEN_DATA_USAGE_STATS_FAIL,
        payload: "Błąd przy pobieraniu danych"
      })
    }
  };
}

export const getScreenStatsRankingGroupByMac = (dateFrom, dateTo) => {
  return async (dispatch) => {
    try {  
      const {data, status} = await api.post('/screenStats/getScreenStatsRankingGroupByMac', {dateFrom, dateTo})
      if(status == 200){
        dispatch({
          type: GET_SCREENS_STATS_RANKING_SUCCESS,
          payload: {
            totalGlobalBytesAmount: data.totalGlobalBytesAmount,
            globalScreenStatsRecords: data.globalScreenStatsRecords
          }
        })
      }else{
        dispatch({
          type: GET_SCREENS_STATS_RANKING_FAIL,
          payload: data
        })
      }
    } catch (error) {
      dispatch({
        type: GET_SCREENS_STATS_RANKING_FAIL,
        payload: error.response.data
      })
    }
  }
}

export const getScreenStatsRankingByMacAndPeriod = (mac, dateFrom, dateTo) => {
  return async (dispatch) => {
    if(mac && dateFrom && dateTo){
      try {
        const {data, status} = await api.post('/screenStats/getScreenDataUsageStaticsPeriod', {screenMac: mac, dateFrom, dateTo})
        dispatch({
          type: GET_SCREEN_STAT_RANKING_DETAILS,
          payload: data.periodScreenStats
        })
      } catch (error) {
        dispatch({
          type: GET_SCREEN_STAT_RANKING_DETAILS_FAIL,
          payload: error.response.data
        })
      }
    }else{
      dispatch({
        type: GET_SCREEN_STAT_RANKING_DETAILS,
        payload:  null
      })
    }
  }
}

export const get20daysUsersScreenStats = (days) => {
  return async (dispatch) => {
    try{ 
      const { data } = await api.post('/screenStats/get20daysUsersScreenStats', {
        days: Number(days)
      })
      dispatch({
        type: GET_TWENTY_DAYS_USER_STATS,
        payload: data.twentyDaysStats
      })
    } catch (error) {
      dispatch({
        type: GET_SCREEN_STAT_RANKING_DETAILS_FAIL,
        payload: 'ServerErr'
      })
    }
  }
}

export const getUserScreensRanking = (days, page) => {
  return async (dispatch) => {
    try{ 
      const reqOb = {
        days: days
      }
      if(page){
        reqOb.page = page
      }
      const { data } = await api.post('/screenStats/getUserScreensRanking', {
        ...reqOb
      })
      dispatch({
        type: GET_USER_RANKING,
        payload: data
      })
    } catch (error) { }
  }
}

export const getInternetUsageRankingByUsers = (days, page) => {
  return async (dispatch) => {
    try {
      const reqOb = {
        days: days
      }
      if(page){
        reqOb.page = page
      }
      const { data } = await api.post('/screenStats/getInternetUsageRankingByUsers', {
        ...reqOb
      })
      dispatch({
        type: GET_INTERNET_USAGE_PER_USER,
        payload: data
      })
    } catch (error) { }
  } 
}
